package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import se.mittpass.shared.api.UpdateWorkplaceRequest
import se.mittpass.shared.api.WorkplaceDto

class WorkplacesRepository(private val httpClient: HttpClient) {
    suspend fun getWorkplaces(): Result<List<WorkplaceDto>> = runCatching {
        httpClient.get("workplaces").body()
    }

    suspend fun updateWorkplace(workplaceId: Long, req: UpdateWorkplaceRequest): Result<Unit> = runCatching {
        httpClient.patch("workplaces/$workplaceId") {
            setBody(req)
        }
    }
}
